// 繁體中文

export default {
  app: {
    name: '隱分寶',
    shortSlogan: '安安靜靜 看個回放！'
  },

  // 產品文案唯一真相源。所有頁面/SEO/JSON-LD 的產品介紹文案必須從這裡取，
  // 不要在別處另寫一份。引用方式：`@:product.shortIntro` / `@:product.longIntro` /
  // `@:product.aboutIntro` / `@:product.capabilities`。
  // 見 docs/mainadr/0008-shared-product-copy.md。
  product: {
    shortIntro: '隱分寶是一個在觀看體育賽事回放時，自動隱藏比賽回放頁面下的比分、封面、標題、評論等劇透資訊的瀏覽器擴充功能（套件），支援 Chrome、Edge、Firefox 三瀏覽器。',
    longIntro: '隱分寶是一個在觀看體育賽事回放時，自動隱藏比賽回放頁面下的比分、封面、標題、評論等劇透資訊的瀏覽器擴充功能（套件），可以在觀看回放時免被任何劇透資訊干擾！',
    aboutIntro: '隱分寶（Replay Shield）是一款瀏覽器擴充功能，自動隱藏主流體育視訊網站的賽事比分和劇透資訊，幫助你在觀看比賽回放或精彩集錦時保留觀賽懸念。所有辨識與隱藏邏輯均在本地瀏覽器執行，資料不出端。',
    capabilities: [
      '一鍵開關：總開關即時切換，所有支援的網站全域生效',
      '資訊隱藏：自動隱藏標題、封面、比分、評論等劇透元素',
      '載入遮罩：頁面載入完成後才解除進度條遮罩',
      '開頭遮擋：播放前遮擋面板蓋住畫面，避免開局爆雷',
      '本地優先：所有邏輯在您的瀏覽器內執行，偏好不離開裝置'
    ]
  },

  slogan: '體育賽事回放劇透資訊隱藏助手',

  nav: {
    home: '首頁',
    features: '功能特性',
    install: '安裝指南',
    guide: '使用說明',
    matrix: '終端支援',
    faq: '常見問題',
    about: '關於',
    privacy: '隱私',
    terms: '協議',
    download: '下載',
    login: '登入',
    account: '帳號',
    accountCenter: '個人中心',
    subscribe: 'Pro 會員',
    upgradeCta: '開通 Pro 會員'
  },

  seo: {
    siteName: '隱分寶',
    shortName: 'Replay Shield',
    description: '@:product.shortIntro',
    keywords: '隱分寶,Replay Shield,比分隱藏,劇透隱藏,體育回放,瀏覽器擴充,Chrome 擴充,Edge 擴充,Firefox 擴充',
    ogImage: '/og/default.png',

    home: {
      title: '隱分寶 — 體育賽事回放劇透資訊隱藏助手',
      description: '@:product.longIntro'
    },
    install: {
      title: '安裝指南 — 隱分寶',
      description: '隱分寶支援 Chrome / Edge / Firefox 三瀏覽器商店一鍵安裝，以及 360、QQ、獵豹、Opera 等其他瀏覽器手動 .crx 安裝。'
    },
    guide: {
      title: '使用說明 — 隱分寶',
      description: '裝完隱分寶後怎麼用？三步進入管理控制台開始觀賽；賽事導航、遮罩層、開頭遮擋、進度條防護等觀賽設定詳解，足球與籃球賽事通用的使用說明。'
    },
    about: {
      title: '關於隱分寶',
      description: '@:product.aboutIntro'
    },
    subscribe: {
      title: 'Pro 會員 — 隱分寶',
      description: '隱分寶 Pro 會員：免費檔涵蓋第三方賽事導航，Pro 會員解鎖國內外賽事導航與完整劇透防護。新用戶註冊即享 {days} 天 Pro 試用，月度 / 季度 / 年度三檔方案，邀請好友雙方都有好禮，支援兌換碼兌換。',
      descriptionMeta: '隱分寶 Pro 會員：免費檔涵蓋第三方賽事導航，Pro 會員解鎖國內外賽事導航與完整劇透防護。新用戶註冊即享 Pro 試用，月度 / 季度 / 年度三檔方案，邀請好友雙方都有好禮，支援兌換碼兌換。'
    },
    login: {
      title: '登入 — 隱分寶',
      description: '登入隱分寶帳號，同步觀賽防護設定與 Pro 會員權益；支援信箱密碼登入與 QQ、抖音、Google 第三方登入。'
    },
    account: {
      title: '個人中心 — 隱分寶',
      description: '管理你的隱分寶帳號：訂閱權益、訂單記錄、邀請獎勵與帳號安全設定。'
    },
    privacy: {
      title: '隱私政策 — 隱分寶',
      description: '隱分寶尊重並保護所有使用者的隱私。本政策說明我們如何收集、使用和保護您的資訊。'
    },
    terms: {
      title: '使用者協議 — 隱分寶',
      description: '隱分寶（Replay Shield）使用者協議。請仔細閱讀，使用本產品即視為您同意本協議全部條款。'
    },
    refund: {
      title: '退款政策 — 隱分寶',
      description: '隱分寶 Pro 會員訂閱退款政策：虛擬數位商品不支援無理由全額退款；特殊情況經營運方核實開放退款權限後，依已使用天數比例清算退款。'
    },
    inviteRules: {
      title: '邀請規則 — 隱分寶',
      description: '隱分寶邀請規則：好友透過你的邀請註冊雙方都有好禮，註冊 +5 天、好友首次訂閱再得一半時長；了解綁定規則、受邀折扣與退款收回口徑。'
    },

  notFound: {
      title: '頁面未找到 — 隱分寶',
      description: '您存取的頁面不存在或已被移除。'
    }
  },

  home: {
    hero: {
      title: '比分已藏 · 懸念猶在',
      subtitle: '安安靜靜 看個回放！',
      painLine: '熬不了夜？看回放又被劇透？',
      intro: '@:product.longIntro',
      sellPoints: [
        '劇透自動隱藏',
        '足球籃球雙支援',
        '免費觀賽導航神器'
      ],
      cta: {
        recommendedFor: '為當前瀏覽器推薦',
        detectedCta: '前往 {browser} 商店安裝',
        storeGeneric: '前往應用商店安裝',
        installGuide: '前往安裝指南',
        fallbackHint: '不是 {browser}？查看其他瀏覽器',
        fallbackHintGeneric: '選擇其他安裝方式',
        fallbackLabel: '選擇瀏覽器',
        manualCta: '其他瀏覽器手動安裝',
        manualHint: '適用於 360 極速 / QQ / 搜狗 / 獵豹 / Opera / UC 等',
        availableOn: '支援瀏覽器',
        seeAll: '查看所有下載方式',
        crx: '查看手動安裝指南',
        stores: {
          chrome: 'Chrome应用商店',
          edge: 'Edge应用商店',
          firefox: 'Firefox应用商店'
        }
      }
    },

    sections: {
      features: '功能特性',
      matrix: '終端支援',
      preview: '效果對比',
      quickStart: '快速上手',
      faq: '常見問題',
      sites: '支援站點',
      sitesSubtitle: '這些主流平台上的足球、籃球賽事回放，均可隱藏劇透資訊',
      useCases: '誰需要隱分寶'
    },

    features: {
      title: '功能特性',
      subtitle: '覆蓋觀看體育回放的全部需求，足球與籃球通吃',
      cards: [
        {
          id: 'match-list',
          title: '賽事導航',
          subtitle: '一鍵觀賽',
          desc: '集中展示世界盃、歐冠、英超、西甲、意甲、法甲、德甲與 NBA、CBA 等熱門足球、籃球賽事，每場比賽下列出全場回放、分節影片與集錦，標註來源平台與解說。',
          icon: 'ph:list-bold'
        },
        {
          id: 'info-hide',
          title: '資訊隱藏',
          subtitle: '無劇透瀏覽',
          desc: '開啟目標網頁後，自動隱藏影片標題、封面、簡介、評論與瀏覽器 TITLE 等劇透元素。整頁開啟就是乾淨的回放體驗。',
          icon: 'ph:eye-slash-bold',
          highlight: true
        },
        {
          id: 'progressive',
          title: '漸進式展示',
          subtitle: '節奏自控',
          desc: '比賽列表預設展示回放與集錦，附加影片預設摺疊。先看常規，結束再決定是否展開，按自己的節奏推進，不劇透。',
          icon: 'ph:caret-down-bold'
        },
        {
          id: 'mask',
          title: '載入遮罩',
          subtitle: '瞬間防劇透',
          desc: '頁面開啟時疊加進度條遮罩，防止頁面載入瞬間比分與劇透文字閃現。讓乾淨的回放體驗從第一幀開始。',
          icon: 'ph:shield-bold'
        },
        {
          id: 'cover-intro',
          title: '影片開頭遮擋面板',
          subtitle: '開局防爆雷',
          desc: '影片播放前 N 秒顯示遮擋面板蓋住播放器畫面，防止集錦開頭出現比數爆雷。按設定秒數生效。',
          icon: 'lucide:monitor-play'
        },
        {
          id: 'skip-buttons',
          title: '快進快退浮動按鈕',
          subtitle: '節奏自控',
          desc: '開啟後顯示快進快退浮動按鈕，支援自訂時長，自由控制畫面的快進、快退。',
          icon: 'ph:fast-forward-bold'
        },
        {
          id: 'progress-protection',
          title: '進度條防護',
          subtitle: '時長防推斷',
          desc: '隱藏影片進度條、總時長與結束時間，避免透過時長推斷比賽階段與結果。',
          icon: 'lucide:timer'
        }
      ],
      ctaSubscribe: {
        title: '部分 Pro 會員專屬功能需訂閱',
        desc: '所有用戶均可免費觀看最新熱門足球、籃球回放賽事，基礎功能免費使用。開通 Pro 解鎖劇透隱藏、開頭遮擋、進度條防護等更多能力，新用戶註冊即享 Pro 試用。',
        cta: '查看 Pro 會員方案'
      }
    },

    quickStart: {
      subtitle: '三步開始觀賽；不同裝置的完整步驟見安裝指南。',
      deviceTabs: { desktop: '電腦端', mobile: '手機端' },
      notice: '友情提示：隱分寶只對從控制台賽事導航開啟的網頁生效劇透遮擋，對其他來源開啟的網站不生效。',
      ctaInstall: '查看完整安裝指南',
      ctaGuide: '功能與設定詳解',
      steps: {
        desktop: [
          {
            title: '安裝擴充功能',
            desc: '在 Chrome / Edge / Firefox 商店一鍵安裝，或手動安裝 .crx。'
          },
          {
            title: '進入管理控制台',
            desc: '點擊工具列的隱分寶圖示，在彈出小視窗點「進入管理控制台」。'
          },
          {
            title: '從賽事導航觀賽',
            desc: '選一場足球或籃球比賽點擊前往，比分、標題自動隱藏。'
          }
        ],
        mobile: [
          {
            title: '安裝瀏覽器與擴充功能',
            desc: '手機端用 Edge 或 Firefox：在擴充功能選單中搜尋隱分寶並安裝。'
          },
          {
            title: '進入管理控制台',
            desc: '在擴充功能選單點擊隱分寶，彈出介面點「進入管理控制台」。'
          },
          {
            title: '從賽事導航觀賽',
            desc: '選一場比賽點擊前往，劇透資訊自動隱藏。'
          }
        ]
      }
    },

    useCases: {
      title: '誰需要隱分寶',
      subtitle: '真實使用場景下的人群畫像',
      cases: [
        {
          icon: 'lucide:briefcase',
          title: '第二天要上班的學生與上班族',
          desc: '早九晚五的生活節奏讓人無法熬夜追直播，第二天看重播時又被標題、封面、評論裡的劇透資訊干擾。'
        },
        {
          icon: 'ph:trophy-bold',
          title: '熱愛體育的資深球迷',
          desc: '無論看英超、歐冠、世界盃還是 NBA，都希望保留「直播般的懸念感」。隱分寶讓回放也有第一次看球的心跳。'
        },
        {
          icon: 'lucide:monitor-play',
          title: '手機端長影片觀看者',
          desc: '通勤、外出、睡前用手機看重播與集錦的人。手機端同樣支援完整的劇透隱藏。'
        }
      ]
    },

    whatIsYfb: {
      eyebrow: 'WHAT IS REPLAY SHIELD',
      title: '什麼是隱分寶',
      lead: '當錯過體育賽事直播，想要重溫體育賽事回放時，卻看到比分、標題、封面、評論裡都充滿著劇透資訊。這總是會讓體育愛好者失去觀賽樂趣！',
      pains: [
        {
          icon: 'lucide:moon',
          title: '熬不了夜',
          desc: '工作日沒法熬夜追直播，第二天看重播時比分早已在標題、封面、推送裡刷過一遍，懸念全無。'
        },
        {
          icon: 'lucide:tv',
          title: '錯過直播',
          desc: '幾天後才補看世界盃決賽、歐冠半決賽或 NBA 搶七大戰，社群媒體與新聞標題早已滿屏劇透，點開頁面就被結果迎面砸來。'
        },
        {
          icon: 'lucide:message-square-warning',
          title: '被劇透包圍',
          desc: '影片封面的「全場 3-1」、標題裡的「冠軍誕生」、評論區裡的「太強了哈蘭德」「絕殺太燃了」——每一個元素都在劇透。'
        }
      ],
      introTag: 'INTRO',
      intro: '隱分寶是一個在觀看體育賽事回放時，自動隱藏比賽回放頁面下的比分、封面、標題、評論等劇透資訊的瀏覽器擴充功能（套件），可以在觀看回放時免被任何劇透資訊干擾！'
    },

    preview: {
      title: '效果預覽',
      subtitle: '看看隱分寶如何在不同設備上守護你的觀賽懸念',
      beforeLabel: '啟用插件前',
      afterLabel: '啟用插件後',
      beforeHint: '比分清晰可見',
      afterHint: '比分已被隱藏',
      switchHint: '點擊切換查看效果',
      mockPage: {
        pageTitle: '熱門賽事 · 回放列表',
        siteLabel: '示例站點',
        badgeSpoiler: '劇透可見',
        badgeProtected: '已保護',
        statusToggle: '插件狀態',
        statusOn: '已啟用',
        statusOff: '已關閉',
        placeholder: {
          title: '[隱分寶：標題]',
          score: '[隱分寶：比分]',
          thumbnail: '[隱分寶：封面]',
          comment: '[隱分寶：評論]',
          league: '[隱分寶：聯賽]'
        },
        matches: [
          {
            league: '英超第 28 輪',
            homeTeam: '曼城',
            awayTeam: '利物浦',
            homeShort: 'MNC',
            awayShort: 'LIV',
            homeScore: 3,
            awayScore: 1,
            status: '已結束',
            time: '04-12 · 23:30',
            title: '曼城 3-1 利物浦 · 哈蘭德雙響 薩拉赫扳回一城',
            thumbnailLabel: '回放封面',
            comments: ['太強了哈蘭德！', '利物浦下半場崩了', '曼城冠軍穩了']
          },
          {
            league: '西甲第 30 輪',
            homeTeam: '皇馬',
            awayTeam: '巴薩',
            homeShort: 'RMA',
            awayShort: 'BAR',
            homeScore: 2,
            awayScore: 2,
            status: '已結束',
            time: '04-13 · 03:00',
            title: '國家德比 2-2 戰平 維尼修斯絕平',
            thumbnailLabel: '回放封面',
            comments: ['國家德比永遠精彩', '維尼修斯是真核', '巴薩防線堪憂']
          },
          {
            league: 'NBA 季後賽',
            homeTeam: '湖人',
            awayTeam: '勇士',
            homeShort: 'LAL',
            awayShort: 'GSW',
            homeScore: 112,
            awayScore: 108,
            status: '已結束',
            time: '04-14 · 10:30',
            title: '湖人 112-108 險勝勇士 詹姆斯大三元',
            thumbnailLabel: '回放封面',
            comments: ['老詹還是穩', '庫里差一點點', '湖人總冠軍？']
          },
          {
            league: '歐冠 1/4 決賽',
            homeTeam: '拜仁',
            awayTeam: '阿森納',
            homeShort: 'BAY',
            awayShort: 'ARS',
            homeScore: 1,
            awayScore: 0,
            status: '已結束',
            time: '04-15 · 03:00',
            title: '拜仁 1-0 小勝阿森納 凱恩頭球致勝',
            thumbnailLabel: '回放封面',
            comments: ['阿森納可惜了', '凱恩大場面先生', '次回合懸念還在']
          }
        ]
      }
    },

    matrix: {
      title: '終端支援',
      subtitle: '隱分寶目前已支援主流瀏覽器 + 主流作業系統',
      headers: ['Chrome', 'Edge', 'Firefox'],
      platforms: ['Windows / macOS', 'Android', 'iOS / iPadOS', 'HarmonyOS'],
      rows: [
        ['支援', '支援', '支援'],
        ['不支援', '支援', '支援'],
        ['不支援', '不支援', '不支援'],
        ['不支援', '支援', '支援']
      ],
      legend: {
        yes: '支援',
        limited: '部分支援',
        no: '不支援'
      }
    },

    faq: {
      title: '常見問題',
      subtitle: '關於隱分寶的常見疑問解答',
      items: [
        {
          q: '為什麼啟用後有些網站比分還顯示？',
          a: '可能是該網站近期改版。可以透過頁面底部的回饋管道告訴我們，我們會儘快跟進適配。'
        },
        {
          q: '插件會不會影響網頁其他功能？',
          a: '不會。插件只隱藏比分、標題、封面、評論等劇透相關元素，不影響影片播放和其他互動。'
        },
        {
          q: '支援籃球比賽嗎？',
          a: '支援。隱分寶同時提供足球與籃球賽事導航（NBA、CBA 等），劇透隱藏能力對兩類賽事同等生效，控制台左側可隨時切換。'
        },
        {
          q: '如何在啟用狀態下臨時查看比分？',
          a: '可以暫時關閉插件開關，重新整理頁面後即可查看比分。'
        },
        {
          q: '移動端（iOS）為什麼找不到擴充功能入口？',
          a: 'iOS 系統的瀏覽器核心受 Apple 限制，擴充功能能力有限。建議使用桌面端瀏覽器獲得完整體驗。'
        },
        {
          q: '本地安裝後提示「無法驗證擴充功能來源」是正常的嗎？',
          a: '正常現象，這是瀏覽器的安全保護。選擇「保留」即可繼續使用。'
        },
        {
          q: '卸載插件會影響已儲存的資料嗎？',
          a: '不會。卸載插件僅移除擴充功能本身，不會影響瀏覽器其他資料。'
        }
      ]
    },

    meta: {
      title: '隱分寶 — 讓回放也有直播體驗',
      description: '體育賽事回放劇透資訊隱藏助手，支援 Chrome、Edge、Firefox 三瀏覽器。'
    }
  },

  // 使用說明（how-to 操作手冊 + 控制台功能詳解）。與法律「使用說明/聲明」(/terms#specific-features)
  // 嚴格區分，見 CONTEXT.md「使用指南 vs 使用說明」。文案須可執行、負責任，禁止空話。
  guide: {
    eyebrow: 'GUIDE · 使用說明',
    title: '使用說明',
    subtitle: '安裝完成後，從這裡開始：三步進入觀賽，再了解控制台的每一項能力。',
    intro: '隱分寶的賽事導航與觀賽設定都集中在「管理控制台」裡：點擊瀏覽器工具列的隱分寶圖示，在彈出小視窗中點「進入管理控制台」即可進入。',
    installFirst: '還沒裝？先看安裝指南',

    quick: {
      title: '三步開始觀賽',
      mobileNote: '手機端（Android / HarmonyOS）：用 Edge 或 Firefox 安裝後，在瀏覽器擴充功能選單裡點擊隱分寶 → 「進入管理控制台」。iOS 暫不支援。',
      steps: [
        {
          title: '安裝擴充功能',
          desc: '在 Chrome / Edge / Firefox 商店一鍵安裝，或手動安裝 .crx。'
        },
        {
          title: '進入管理控制台',
          desc: '點擊工具列的隱分寶圖示，在彈出的小視窗裡點「進入管理控制台」。'
        },
        {
          title: '從賽事導航觀賽',
          desc: '選一場足球或籃球比賽點擊前往觀賽，比分、標題、封面等劇透資訊自動隱藏。'
        }
      ]
    },

    nav: {
      title: '賽事導航',
      intro: '控制台的賽事導航按「體育偏好」分為足球與籃球兩類，兩側結構完全一致：',
      items: [
        {
          title: '足球 / 籃球切換',
          desc: '左側選單「賽事」分組下隨時切換足球與籃球；兩側都是每日更新的已完賽賽事回放與集錦。'
        },
        {
          title: '頻道與聯賽篩選',
          desc: '頂部頻道選擇器切換國際 / 國內來源，聯賽標籤橫向篩選，快速定位想看的比賽。'
        },
        {
          title: '影片分區',
          desc: '每場比賽下分「全場回放」「比賽集錦」等分區，標註來源平台與解說員，點開即看。'
        },
        {
          title: '收藏',
          desc: '登入後可整場收藏比賽，之後在左側「收藏」中一鍵回看。'
        }
      ]
    },

    settings: {
      title: '觀賽設定',
      intro: '在控制台左側選單進入「設定」，按個人需求調整（未登入或權益未生效時部分項會鎖定）：',
      groups: [
        {
          title: '功能',
          items: [
            '開啟插件：總開關，關閉後所有功能暫停',
            '遮罩層：0–10 秒可調，阻擋剛進入網頁時的劇透閃現',
            '體育偏好：全部 / 足球 / 籃球',
            '桌面版網頁：手機端以桌面版載入支援的站點（需手動開啟）'
          ]
        },
        {
          title: '播放',
          items: [
            '影片開頭遮擋面板：0–60 秒，蓋住影片開頭的比分畫面',
            '隱藏結束時間 / 隱藏進度條：防止透過時長推斷比賽走向',
            '快進快退面板：10 秒到 30 分鐘共 6 檔步長',
            '全螢幕鎖定：全螢幕觀看時的輔助防護'
          ]
        },
        {
          title: '外觀',
          items: [
            '配色：霓虹青 / 終端綠 / 電光藍 / 幻影紫 / 落日金 / 晨曦白 六套',
            '介面語言：簡體中文 / 繁體中文 / English'
          ]
        }
      ]
    },

    entitlement: {
      title: '免費與 Pro 會員',
      desc: '第三方賽事導航與賽事瀏覽（足球 / 籃球賽事列表、漸進式摺疊、解說員標註）對所有用戶免費開放；國內外賽事導航、劇透資訊隱藏、載入遮罩、開頭遮擋、進度條防護等為 Pro 會員能力。新用戶註冊即享 Pro 試用。',
      cta: '查看 Pro 會員方案'
    },

    scope: '友情提示：隱分寶只對從控制台賽事導航開啟的網頁生效劇透遮擋，對其他來源開啟的任意網站不生效。'
  },

  footer: {
    copyright: '© 2026 隱分寶',
    brandDesc: '@:product.longIntro',
    sections: {
      product: '產品',
      legal: '法律',
      social: '追蹤我們'
    },
    links: {
      membership: 'Pro 會員',
      features: '功能特性',
      install: '安裝指南',
      guide: '使用說明',
      matrix: '終端支援',
      download: '下載',
      about: '關於我們',
      faq: '常見問題',
      privacy: '隱私政策',
      terms: '使用者協議',
      refund: '退款政策',
      invite: '邀請規則',
    },
    social: {
      wechatGzh: {
        title: '微信公眾號',
        hint: '膨脹的球（搜尋關注）'
      },
      wechatGroup: {
        title: '反饋交流群',
        hint: '使用者反饋與交流'
      }
    }
  },

  common: {
    back: '返回',
    learnMore: '了解更多',
    getStarted: '立即開始',
    yes: '是',
    no: '否',
    loading: '載入中...',
    error: '出錯了',
    retry: '重試',
    close: '關閉'
  },

  login: {
    title: '登入',
    email: '信箱',
    emailPlaceholder: 'name\\@example.com',
    nickname: '暱稱（可選）',
    nicknamePlaceholder: '怎麼稱呼你？',
    password: '密碼',
    newPassword: '新密碼',
    passwordPlaceholder: '8-20位，含大寫、小寫字母與數字',
    confirmPassword: '確認密碼',
    confirmPasswordPlaceholder: '再次輸入密碼',
    passwordMismatch: '兩次輸入的密碼不一致',
    passwordIncorrect: '密碼不正確',
    showPassword: '顯示密碼',
    hidePassword: '隱藏密碼',
    passwordStrength: '密碼強度',
    passwordWeak: '弱',
    passwordMedium: '中',
    passwordStrong: '強',
    code: '驗證碼',
    codePlaceholder: '6位數字',
    sendCode: '發送驗證碼',
    codeSent: '驗證碼已發送，請查收郵件',
    resetSuccess: '密碼重設成功，請使用新密碼登入',
    sessionExpired: '登入已失效，請重新登入',
    kicked: '您的帳號已在其他裝置登出，請重新登入',
    submit: '提交',
    submitError: '操作失敗，請稍後重試',
    privacyPolicy: '《隱私政策》',
    callbackTitle: '登入成功',
    callbackReturning: '正在返回隱分寶…',
    callbackCountdown: '即將自動返回隱分寶（{n} 秒）',
    callbackGoAccount: '前往個人中心',
    callbackOpenConsole: '開啟隱分寶控制台',
    resumeTitle: '網頁端已登入',
    resumeContinue: '繼續以該帳號登入',
    resumeSwitch: '更換帳號',
    callbackReturnNow: '立即返回隱分寶',
    callbackWeakHint: '若長時間未返回，請在瀏覽器工具列中點擊隱分寶圖示查看登入狀態',
    rememberAccount: '記住帳號',
    rememberPassword: '記住密碼',
    agreePrefix: '已閱讀並同意',
    terms: '《使用者協議》',
    agreeAnd: '與',
    agreeRequired: '請先閱讀並同意《使用者協議》與《隱私政策》',
    sliderTitle: '安全驗證',
    sliderHint: '拖動滑塊，完成拼圖',
    sliderLoading: '載入中…',
    sliderFail: '驗證失敗，請重試',
    sliderRefresh: '重新整理',
    withQQ: '使用QQ登入',
    withDouyin: '使用抖音登入',
    withGoogle: '使用Google登入',
    backToLogin: '返回登入',
    forgotLink: '忘記密碼？',
    goLogin: '已有帳號？前往登入',
    goRegister: '沒有帳號？立即註冊',
    signIn: '登入',
    signUp: '註冊',
    oauthDivider: '或使用第三方帳號登入',
    oauthError: '第三方登入失敗，請重試或使用信箱密碼登入'
  },

  cashier: {
    title: '完成付款',
    chooseChannel: '選擇付款方式',
    payWechat: '微信支付',
    wechatDesc: '掃碼付款',
    payAlipay: '支付寶',
    alipayDesc: '跳轉支付寶收銀台',
    days: '{days} 天',
    wechatTip: '請使用微信「掃一掃」辨識二維碼付款',
    alipayTip: '前往支付寶完成付款，付款成功後本頁將自動確認結果。',
    alipayGo: '前往支付寶付款',
    wechatGo: '微信付款',
    wechatGoTip: '送出後將展示付款二維碼，請使用微信掃碼付款',
    initiating: '正在處理…',
    quoteRetry: '重試報價',
    originalPrice: '原價',
    reopen: '重新開啟付款頁',
    awaitingCheck: '開啟支付頁面完成支付後，將自動確認結果',
    pollChecking: '正在確認付款結果…',
    staleCheck: '確認逾時，可重新整理後繼續等待，或稍後到個人中心繼續付款',
    refreshStatus: '已付款？點此重新整理',
    timeoutMsg: '長時間未確認，可嘗試重建二維碼或重新開啟付款頁',
    refreshQr: '重建二維碼',
    doneTitle: '付款成功',
    doneDesc: '訂閱已生效，感謝支持！瀏覽器擴充功能將同步解鎖 Pro 會員權益。',
    doneCta: '好的',
    expiredTitle: '訂單未完成',
    closedMsg: '訂單已關閉，如需訂閱請重新下單',
    okay: '知道了',
    discountTitle: '優惠選擇',
    discountDefault: '預設最優',
    discountRecommend: '推薦',
    discountSave: '省 ¥{amount}',
    discount: {
      activity: '限時活動',
      inviteFirst: '受邀首單',
      firstOrder: '首訂優惠',
      renewal: '續費優惠',
      noDiscount: '不使用優惠'
    },
    inviteBindDesc: '確認與 {name}（{account}）綁定邀請關係（終身、僅此一次）？',
    inviteAccept: '確認綁定',
    inviteDecline: '不綁定',
    consentNote: '付款即代表你已閱讀並同意',
    consentTerms: '《使用者協議》',
    consentAnd: '與',
    consentRefund: '《退款政策》'
  },
  account: {
    title: '個人中心',
    notLoggedIn: '您尚未登入',
    sections: {
      benefits: '我的權益',
      invites: '我的邀請',
      orders: '我的訂單',
      profile: '個人資訊'
    },
    benefitsDesc: '查看 Pro 會員詳情、兌換碼使用記錄與權益流水',
    invitesDesc: '查看你的邀請碼與邀請產生的獎勵流水',
    profileDesc: '管理你的暱稱',
    ordersDesc: '查看訂單進度與權益明細；特殊情況退款需先經客服核實開通權限',
    nickname: '暱稱',
    email: '信箱',
    edit: '修改',
    editNickname: '修改暱稱',
    notBound: '未綁定',
    bindEmail: '綁定信箱',
    passwordSet: '已設定',
    passwordNotSet: '未設定',
    password: '密碼',
    changePassword: '修改密碼',
    oldPassword: '原密碼',
    newPassword: '新密碼',
    deleteAccount: '註銷帳戶',
    deleteHint: '註銷後帳戶資料將被刪除且不可復原，請謹慎操作。',
    deleteConfirmPassword: '輸入密碼確認',
    deleteConfirm: '我已了解註銷後果，確認註銷',
    save: '儲存',
    cancel: '取消',
    confirm: '確認',
    saved: '儲存成功',
    emailSaved: '信箱修改成功',
    emailBoundSaved: '信箱綁定成功',
    passwordSaved: '密碼修改成功，請重新登入',
    samePassword: '新密碼不能與原密碼相同',
    logout: '登出',
    logoutConfirm: '確定要登出嗎？登出後將同時登出瀏覽器擴充功能。',
    emailVerified: '已驗證',
    operationError: '操作失敗，請稍後重試',
    // 第三方帳號綁定（ADR-0041）
    loginMethodsTitle: '登入方式',
    oauthHint: '綁定後可用該第三方帳號直接登入本帳號',
    oauthBind: '綁定',
    oauthBoundLabel: '已綁定',
    oauthBound: '已成功綁定 {provider}',
    oauthBindError: '綁定失敗，請重試',
    noEmailHint: '綁定信箱並設定密碼後，即可用信箱登入與找回帳號',
    setPassword: '設定密碼',
    setPasswordHint: '你目前透過第三方登入、尚未設定密碼；設定後即可用「信箱 + 密碼」登入',
    subscriptionStatus: '權益狀態',
    subscriptionNone: '目前沒有有效權益',
    subscriptionTrial: '試用中 · 剩餘 {days} 天',
    subscriptionActive: 'Pro 會員 · 至 {date}',
    subscriptionExpired: 'Pro 會員已於 {date} 結束',
    subscribeNow: '開通 Pro 會員',
    hero: {
      daysLeft: '剩餘 {days} 天',
      expiresAt: '至 {date} 到期',
      daysLeftLabel: '剩餘天數',
      expiresAtLabel: '到期時間',
      daysUnit: '天'
    },
    inviteCode: '我的邀請碼',
    inviteLink: '邀請連結',
    inviteHint: '好友透過你的邀請碼註冊或訂閱，雙方都有好禮',
    invitesEmpty: '暫時無法取得邀請碼，請稍後再試',
    copyInviteLink: '複製邀請連結',
    copied: '已複製',
    memberBadge: {
      pro: 'PRO',
      trial: '試用'
    },
    rewards: {
      title: '邀請流水',
      total: '累計獲得 {days} 天',
      empty: '暫無邀請流水。邀請好友註冊你可獲得獎勵天數，好友首次開通 Pro 會員你再獲得對應時長獎勵',
      loadMore: '載入更多',
      retracted: '已收回',
      subscribeNode: '首次訂閱',
      registerNode: '註冊'
    },
    recordsTitle: '權益流水',
    recordsEmpty: '暫無權益記錄',
    recordTrial: '試用',
    recordSubscribe: '訂閱',
    recordInviteReward: '邀請獎勵',
    recordRedeem: '兌換碼',
    recordAdjust: '人工調整',
    recordContribute: '解說獎勵',
    recordRecommend: '推薦獎勵',
    recordAdvice: '回饋補償',
    recordDays: '延長 {days} 天',
    recordDaysDeduct: '扣減 {days} 天',
    recordAt: '至 {date}',
    ordersTitle: '訂單記錄',
    ordersEmpty: '暫無訂單',
    ordersEmptyDesc: '開通 Pro 會員後，付款與退款記錄都會在這裡',
    ordersLoadMore: '載入更多訂單',
    // 價格折扣項展示名（後端只發 key，label 前端三語渲染；互斥取最優至多一項生效）
    discount: {
      activity: '活動折扣',
      inviteFirst: '受邀首單折扣',
      firstOrder: '首訂折扣',
      renewal: '續訂折扣',
      adminAdjust: '後台改價'
    },
    plan: {
      monthly: '月度',
      quarterly: '季度',
      yearly: '年度'
    },
    order: {
      pending: '待支付',
      paid: '已支付',
      refundRequested: '退款處理中',
      refunded: '已退款',
      closed: '已取消',
      payNow: '繼續支付',
      cancel: '取消訂單',
      cancelConfirm: '確定取消該待支付訂單嗎？',
      cancelled: '訂單已取消',
      paySucceeded: '支付成功，權益已生效',
      payPending: '訂單已建立，請在訂單內完成支付',
      pendingHint: '待支付訂單有效期為 {minutes} 分鐘，逾時自動關閉',
      pendingExpires: '待支付 · 剩 {minutes} 分鐘後自動關閉',
      emptyCta: '去開通 Pro 會員',
      applyRefund: '申請退款',
      refundPrompt: '請填寫退款原因（選填，僅用於改進）：',
      refundSubmitted: '退款申請已送出',
      cancelManual: '用戶主動取消',
      cancelTimeout: '逾時未付款自動關閉',
      cancelSuperseded: '被新訂單取代'
    },
    channel: {
      wechat: '微信支付',
      alipay: '支付寶',
      mock: '模擬支付'
    },
    cancelDialog: {
      title: '取消訂單',
      confirm: '確定取消該待支付訂單？取消後如需開通請重新下單。'
    },
    refundDialog: {
      title: '申請退款',
      note: '本產品為虛擬數位商品，退款將依已使用天數比例清算；已使用天數含開通當天，無全額退款。',
      breakdownTitle: '退款明細',
      paidAt: '開通日期',
      used: '已使用（含今天）',
      remaining: '剩餘天數',
      total: '套餐天數',
      paidAmount: '實付金額',
      refundAmount: '本次退款',
      refundAmountTip: '退款金額 = 實付 × 剩餘天數 ÷ 套餐天數（向下取分）',
      confirmNote: '確認退款後立即原路退回，權益將依剩餘天數收回；邀請人獎勵將全額收回，首單資格不返還。',
      discountLossNote: '退款成功後，本次已使用的優惠（如首訂 / 受邀首單折扣）將不返還，後續訂閱可能不再享受首訂優惠。',
      agreePolicy: '我已閱讀並同意',
      policy: '《退款政策》',
      agreeRequired: '請先勾選已閱讀《退款政策》',
      reason: '如果您對產品有任何不滿意，可以告訴我們，方便我們做得更好（選填）',
      submit: '確認退款',
      notEligible: '該訂單已無可退金額'
    },
    orderDetail: {
      title: '訂單詳情',
      orderNo: '訂單號 {no}',
      amount: '金額明細',
      original: '套餐原價',
      discount: '折扣優惠',
      channel: '付款方式',
      inviter: '邀請人：{name}',
      payable: '實付金額',
      timeline: '處理進度',
      created: '下單時間',
      paidAt: '支付完成',
      entitledUntil: '權益至',
      refundRequestedAt: '送出退款',
      refundedAt: '退款完成',
      closedAt: '訂單關閉',
      refundReason: '退款原因',
      refundReview: '審核意見',
      refundPolicy: '退款政策',
      resubscribe: '再次訂閱'
    }
  },

  subscribe: {
    hero: {
      title: 'Pro 會員',
      subtitle: '免費檔提供第三方賽事導航；開通 Pro 會員解鎖國內外賽事導航與完整劇透防護。新用戶註冊即享 {days} 天 Pro 試用。',
      ctaLogin: '登入'
    },
    chip: {
      invited: '受邀首單 {off}',
      firstOrder: '首次開通 {off}',
      renewal: '訂閱期內續費 {off}',
      default: '訂閱解鎖全部防護'
    },
    campaign: {
      tag: '限時活動',
      countdown: '距結束',
      days: '天',
      deadline: '截至',
      hint: '本期為限時活動價，續費將依續訂優惠計算'
    },
    scenes: {
      title: '看重播，不被告劇透',
      subtitle: '隱分寶在影片頁面即時遮擋比分與關鍵事件，安心回看每一場',
      demo: {
        without: '未開啟防護',
        with: 'Pro 會員已開啟',
        teams: '阿仙納 vs 切爾西 · 英超第 30 輪',
        score: '2 - 1',
        scorer: '薩卡 78 分鐘破門',
        hidden: '已隱藏'
      },
      s1: {
        title: '重播防劇透',
        desc: '回看比賽時自動遮擋比分、進球隊與關鍵事件，看完再揭曉'
      },
      s2: {
        title: '精彩瞬間回看',
        desc: '進球、紅牌、點球等關鍵時刻逐段回看，不被結果搶先劇透'
      },
      s3: {
        title: '賽季檔案收藏',
        desc: '整場比賽收藏進檔案，資料永不失效，隨時回看'
      }
    },
    badge: {
      activity: '限時活動',
      inviteFirst: '受邀首單',
      firstOrder: '首訂優惠',
      renewal: '續費優惠',
      noDiscount: '不使用優惠'
    },
    offZhe: '{value} 折',
    offPercent: '{percent}% off',
    status: {
      trial: '試用中 · 剩餘 {days} 天',
      subscribed: 'Pro 會員 · 至 {date}',
      expired: 'Pro 會員已於 {date} 結束',
      trialExpired: '試用已於 {date} 結束',
      none: '訂閱解鎖完整防護',
      refresh: '重新整理權益狀態'
    },
    compare: {
      title: '免費與 Pro 會員',
      subtitle: '註冊即可使用免費檔（第三方賽事導航）；開通 Pro 會員解鎖國內外賽事導航與完整劇透防護',
      headerFree: '免費',
      headerSub: 'Pro',
      infoLabel: '功能說明',
      rows: [
        {
          label: '足球第三方賽事導航',
          group: 'free',
          free: true,
          sub: true,
          info: '匯集直播吧、咪咕視頻、愛奇藝、央視體育、央視頻等第三方平台的足球回放與集錦入口，一鍵前往對應平台觀賽。'
        },
        {
          label: '籃球第三方賽事導航',
          group: 'free',
          free: true,
          sub: true,
          info: '匯集直播吧、咪咕視頻、愛奇藝、央視體育、央視頻等第三方平台的籃球回放與集錦入口，一鍵前往對應平台觀賽。'
        },
        {
          label: '漸進式導航展示',
          group: 'free',
          free: true,
          sub: true,
          info: '針對可能進入延長賽或點球大戰的足球、籃球等賽事，延長與點球影片預設折疊。先看完整個常規賽，再自行決定是否展開延長或點球，最大程度避免提前劇透。'
        },
        {
          label: '解說員標註',
          group: 'free',
          free: true,
          sub: true,
          info: '為各個來源網站的回放資源標註解說員資訊，方便選擇喜歡的解說員來觀看賽事。'
        },
        {
          label: '賽事預告',
          group: 'free',
          free: true,
          sub: true,
          info: '未來兩週的賽程時間線，提前看到有哪些比賽、什麼時候開賽、對陣雙方是誰，方便安排觀賽計劃。'
        },
        {
          label: '足球國內外賽事導航',
          group: 'pro',
          free: false,
          sub: true,
          info: '匯集五大聯賽、歐冠、世界盃、歐洲盃等國際頂級賽事，也涵蓋中超、中甲、中乙以及蘇超、村超等全民賽事。每日更新已完賽賽事的回放與集錦，一鍵即可觀賽。'
        },
        {
          label: '籃球國內外賽事導航',
          group: 'pro',
          free: false,
          sub: true,
          info: '涵蓋 NBA、CBA 等籃球重大賽事。每日更新已完賽賽事的回放與集錦，一鍵即可觀賽。'
        },
        {
          label: '劇透資訊隱藏',
          group: 'pro',
          free: false,
          sub: true,
          core: true,
          info: '插件的核心功能：隱藏頁面下的標題、比分、封面、介紹、評論等各種劇透資訊，保證觀看回放時不被劇透打擾。'
        },
        {
          label: '載入遮罩層',
          group: 'pro',
          free: false,
          sub: true,
          info: '網頁載入開始時顯示遮罩層，防止網頁載入初期比分與劇透資訊瞬間閃現。'
        },
        {
          label: '影片開頭遮擋面板',
          group: 'pro',
          free: false,
          sub: true,
          info: '觀看集錦或回放時，防止影片開頭出現比分劇透。可提前設定遮擋面板，按設定秒數蓋住開頭畫面。'
        },
        {
          label: '進度條防護',
          group: 'pro',
          free: false,
          sub: true,
          info: '隱藏進度條與結束時間，避免透過進度與時長提前推斷比賽結果。'
        },
        {
          label: '快進快退浮動按鈕',
          group: 'pro',
          free: false,
          sub: true,
          info: '觀看影片時顯示快進快退浮動按鈕，支援自訂步長，方便按自己的觀看節奏控制進度。'
        },
        {
          label: '設定自動同步',
          group: 'pro',
          free: false,
          sub: true,
          info: '登入後自動同步設定與偏好，更換裝置也能無縫續用，無需重新配置。'
        },
        {
          label: '全螢幕鎖定',
          group: 'pro',
          free: false,
          sub: true,
          info: '影片全螢幕播放時出現鎖定按鈕，點擊後鎖定畫面防誤觸；再點解鎖，退出全螢幕自動解鎖。'
        },
        {
          label: '收藏功能',
          group: 'pro',
          free: false,
          sub: true,
          info: '收藏整場比賽隨時回看，足球與籃球通用；收藏資料服務端保存、永不過期，超出每日更新窗口的場次也能回查。'
        },
        {
          label: '關注（賽事 / 隊伍）',
          group: 'pro',
          free: false,
          sub: true,
          info: '關注自己喜歡的賽事與球隊，賽事頁「關注」標籤只展示關注對象的比賽，並可切換只看「我的球隊」。與「收藏」相互獨立：關注決定看到哪些比賽，收藏用於整場回看。'
        }
      ]
    },
    plans: {
      title: '選擇 Pro 會員方案',
      subtitle: '一次開通，解鎖全部防護能力。',
      bestValue: '最划算',
      days: '{days} 天權益',
      perMonth: '折合 ¥{price}/月',
      save: '較月付立省 ¥{amount}',
      originalPrice: '原價',
      guestNote: '未登入價格為按新用戶資格的預估價，登入後以實際資格為準',
      subscribe: '開通 Pro 會員',
      renew: '續費 Pro 會員',
      processing: '處理中…'
    },
    order: {
      success: '開通成功！權益已延長 {days} 天，至 {date}',
      pending: '訂單已建立（{orderNo}），請在個人中心完成支付'
    },
    resume: {
      pending: '你有一筆未完成的付款訂單',
      continue: '繼續付款',
      alreadyPaid: '該訂單已付款成功，權益已生效',
      expired: '該筆待支付訂單已逾時或被新訂單取代，請重新下單'
    },
    consent: {
      note: '點擊即表示你已閱讀並同意',
      terms: '《使用者協議》',
      and: '與',
      refund: '《退款政策》',
      disclaimer: '本工具僅對受支援的影片頁面提供本地遮擋，不保證所有頁面與所有時刻的完整覆蓋。'
    },
    notice: {
      title: '開通前請了解',
      items: [
        '支付成功後權益立即生效，依未使用時長順延疊加。',
        '本產品為虛擬數位商品，不支援無理由全額退款；特殊情況可聯繫回饋，經核實後依已使用天數比例清算退款。',
        '本工具僅對受支援的影片頁面提供本地遮擋，不保證所有頁面、所有時刻的完整覆蓋。',
        '試用、兌換碼、邀請獎勵、贈送取得的權益不參與退款。'
      ],
      gotIt: '知道了'
    },
    invite: {
      title: '邀請好友，雙方都有好禮',
      subtitle: '好友透過你的邀請連結註冊或開通，雙方都能拿到實實在在的好處。',
      myCode: '我的邀請碼',
      shareHint: '把邀請連結發給好友：好友點擊連結後 24 小時內註冊即與邀請人綁定，雙方立即生效',
      copy: '複製連結',
      copied: '邀請連結已複製',
      invitedDesc: '邀請你開通 Pro 會員，首單立享 {off}',
      clear: '清除',
      clearHint: '清除後按非受邀價格顯示；註冊前清除不會被綁定邀請關係',
      stats: '已邀請 {count} 人 · 已累計獲得 {days} 天',
      friendTitle: '給好友',
      friendRule1: '好友透過你的邀請碼首次開通 Pro 會員，首單立享 {off}',
      meTitle: '給你自己',
      meRule1: '好友註冊成功，你立即獲得 +{days} 天',
      meRule2: '好友首次開通任意 Pro 方案，你再獲得該方案時長的 {percent}%（僅首次開通觸發）',
      rulesLink: '查看完整邀請規則'
    },
    redeem: {
      title: '兌換碼',
      subtitle: '有兌換碼？輸入即可兌換對應時長的 Pro 會員權益。每個帳號限領一次。',
      placeholder: '輸入兌換碼',
      submit: '兌換',
      processing: '兌換中…',
      success: '兌換成功！權益已延長 {days} 天，至 {date}',
      codeRequired: '請輸入兌換碼'
    },
    faq: {
      title: '常見問題',
      items: [
        { q: '為什麼不支援微信登入和微信支付？', a: '產品初次上線僅開放支付寶收單，暫未接入微信登入與微信支付。後續版本會完成微信登入與微信支付的接入，開放後會同步更新登入頁與訂閱頁；當前可先使用支付寶完成付款。' },
        { q: '兌換碼如何獲取？', a: '兌換碼主要來自微信公眾號「膨脹的球」、官方回饋群，以及體驗問題補償與運營活動的發放。獲取後在訂閱頁「兌換碼」區域輸入即可，每個兌換碼僅可使用一次，兌換成功後權益時長立即順延。公眾號與回饋群二維碼見「關於我們」頁。' },
        { q: '好友退款後，我的邀請獎勵會怎樣？', a: '好友的首次訂閱訂單退款後，你因該好友獲得的訂閱獎勵時長會全額收回，權益流水與邀請流水都會標記「已收回」並重新計算你的到期時間；好友註冊時發放的註冊獎勵不收回。' },
        { q: '為什麼沒登入時看到的價格，登入後變了？', a: '未登入時套餐展示的是按新用戶資格計算的預估價；登入後系統按你的真實資格（是否首次訂閱、是否受邀、當期是否有活動）重新計價，因此可能更低，也可能回到原價。最終金額以收銀台顯示為準。' },
        { q: '在收銀台改了優惠選擇會怎樣？', a: '收銀台預設選中對你最優惠的一項，你可以換成其他折扣，也可以選擇不使用優惠。選哪一項就按哪一項的金額實付，訂單明細同樣按所選記錄；無論選哪一項，這筆訂單都算你的首次訂閱。' },
        { q: '試用和兌換碼算首次訂閱嗎？', a: '不算。試用、兌換碼、邀請獎勵與運營贈送都不涉及實付出資，不會消耗首單資格；只有實際支付成功的訂閱訂單才算首次訂閱。' },
        { q: '支付成功但會員沒到帳怎麼辦？', a: '支付結果由系統自動對帳，收銀台會在你付款後自動確認並延長權益，通常數秒內完成。若頁面停留在確認狀態，可點擊「重新整理狀態」，或重新登入後到個人中心查看；仍未到帳時請在瀏覽器擴充功能的「回饋」中提交訂單號，我們核實後會處理。' },
        { q: '換電腦或重裝瀏覽器，會員還在嗎？', a: 'Pro 會員權益綁定帳號而不是裝置。在新瀏覽器安裝擴充功能並登入同一帳號，防護能力與剩餘時長即恢復。只有試用資格按裝置與身分雙重校驗，同一裝置僅可領取一次。' },
        { q: '到期前續費會浪費剩餘天數嗎？', a: '不會。新增時長在當前到期時間之後順延累加，提前續費不會清零；兌換碼與邀請獎勵也按同一規則疊加。你的到期時間可在個人中心與訂閱頁查看。' }
      ]
    },
    errors: {
      loadPlans: '方案資訊載入失敗，請稍後重試',
      noChannel: '支付暫時無法使用，請稍後再試',
      generic: '操作失敗，請稍後重試',
      copyFailed: '複製失敗，請手動複製'
    },
    loading: '載入中…'
  },

  validation: {
    emailRequired: '請輸入信箱',
    emailMax: '信箱長度不能超過100位',
    emailFormat: '信箱格式不正確',
    passwordRequired: '請輸入密碼',
    passwordFormat: '密碼需為8-20位，且包含大寫字母、小寫字母和數字',
    passwordLength: '長度需為8-20位',
    passwordLower: '需包含小寫字母',
    passwordUpper: '需包含大寫字母',
    passwordDigit: '需包含數字',
    passwordSpace: '不能包含空格',
    codeRequired: '請輸入驗證碼',
    codeFormat: '驗證碼為6位數字',
    nameRequired: '請輸入暱稱',
    nameMax: '暱稱長度不能超過30個字元'
  },

  install: {
    crumbs: '麵包屑導覽',
    crumbsHome: '安裝',

    // 分端安裝 tab（桌面 Chrome/Edge/Firefox/其他Chromium + 手機 Edge/Firefox + iOS 卡）
    // 每個端一步到底：安裝 → 固定 → 進入管理控制台 → 觀賽；配圖約定見 docs/main/specs/assets.md
    tabs: {
      title: '安裝隱分寶',
      subtitle: '選擇你的裝置與瀏覽器，跟著步驟裝好並開始觀賽',
      calloutBadge: '推薦桌面端',
      calloutTitle: '商店安裝支援自動更新，最省心',
      groups: { desktop: '電腦端', mobile: '手機端', ios: 'iOS / iPadOS' },
      tabLabels: {
        chrome: 'Chrome',
        chromeManual: 'Chrome · 手動安裝',
        edge: 'Edge',
        firefox: 'Firefox',
        chromium: '其他 Chromium',
        edgeMobile: 'Edge · 手機版',
        firefoxMobile: 'Firefox · 手機版'
      },
      platformBadges: {
        desktop: 'Windows / macOS / Linux',
        android: 'Android / HarmonyOS'
      },
      recommended: '推薦',
      methodBadges: { store: '商店安裝', manual: '手動安裝' },
      intro: {
        chrome: '支援商店安裝和手動安裝兩種方式。推薦商店安裝（支援自動更新，省心省力）；無法存取應用商店時，使用手動安裝。',
        chromeManual: '適用於無法存取 Chrome 線上應用程式商店的情況。注意：手動安裝的版本不會自動更新，建議定期關注官網取得最新版本。',
        edge: 'Edge 支援透過 Edge 載入項商店一鍵安裝。',
        firefox: 'Firefox 支援透過 Firefox 附加元件商店一鍵安裝。',
        chromium: '360 極速 / QQ / 搜狗 / 獵豹 / Opera / UC 等基於 Chromium 核心的瀏覽器，可參照 Chrome 手動安裝方式載入 .crx。',
        edgeMobile: '行動端僅支援 Edge 與 Firefox 兩款瀏覽器，且只支援商店安裝，不支援手動安裝。',
        firefoxMobile: '行動端僅支援 Edge 與 Firefox 兩款瀏覽器，且只支援商店安裝。部分應用商店搜尋不到 Firefox，可用下方 APK 連結安裝瀏覽器。'
      },
      steps: {
        chrome: [
          '打開 Chrome 瀏覽器，前往 Chrome 線上應用程式商店',
          '在搜尋框中輸入「隱分寶」進行搜尋',
          '點擊頁面右側的「添加到 Chrome」',
          '在彈出的確認視窗中，點擊「添加擴充功能」',
          '安裝完成後，Chrome 工具列右側會出現隱分寶圖示',
          '如果圖示被隱藏在擴充功能選單中，點開工具列右側的拼圖圖示，在列表中找到隱分寶，點擊圖釘按鈕將其固定到工具列（推薦），方便後續使用',
          '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
          '進入控制台後，即可在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
        ],
        chromeManual: [
          '打開隱分寶官網手動安裝指南頁，下載 .crx 安裝套件（見下方入口）',
          '點擊瀏覽器選單圖示，找到「擴充功能」，打開管理擴充功能頁面',
          '打開頁面右上角的「開發者模式」開關',
          '將下載好的 .crx 檔案從資料夾中直接拖拽到擴充功能頁面中',
          '在彈出的提示視窗中，點擊「添加擴充功能」',
          '安裝完成後，點擊工具列拼圖圖示，找到隱分寶並點擊圖釘固定到工具列（推薦）',
          '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
          '進入控制台後，即可在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
        ],
        edge: [
          '打開 Edge 瀏覽器，前往 Edge 載入項商店',
          '在搜尋框中輸入「隱分寶」進行搜尋',
          '點擊頁面上的「獲取」按鈕',
          '在彈出的提示視窗中，點擊「添加擴充功能」',
          '安裝完成後，Edge 工具列右側會出現隱分寶圖示',
          '點擊工具列右側的拼圖圖示，在擴充功能列表中找到隱分寶，點擊圖釘按鈕固定到工具列（推薦）',
          '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
          '進入控制台後，即可在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
        ],
        firefox: [
          '打開 Firefox 瀏覽器的擴充功能和佈景主題頁面',
          '在搜尋框中輸入「隱分寶」進行搜尋',
          '點擊頁面上的「添加到 Firefox」按鈕',
          '在彈出的提示視窗中，點擊「添加」',
          '安裝完成後，勾選「將擴充功能固定到工具列」選項',
          '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
          '進入控制台後，即可在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
        ],
        chromium: [],
        edgeMobile: [
          '在各大應用商店搜尋並下載安裝 Edge 瀏覽器',
          '打開 Edge 瀏覽器，進入首頁點擊選單列圖示',
          '在選單介面點擊「擴充功能」，打開擴充功能管理介面',
          '搜尋「隱分寶」，在搜尋結果中找到隱分寶，並點擊「獲取」',
          '彈出提示介面後，點擊「添加」，此時會顯示已安裝',
          '回到首頁，繼續點擊選單列 → 「擴充功能」，會發現多了一個隱分寶',
          '點擊隱分寶，在彈出介面點擊「進入控制台」，即可正常觀賽',
          '也可以點擊左側選單列，自訂觀賽設定'
        ],
        firefoxMobile: [
          '在應用商店搜尋下載安裝 Firefox 瀏覽器；如無法存取 Google Play，可透過下方 APK 連結安裝',
          '打開 Firefox，進入首頁點擊右上角選單圖示',
          '在展開的選單中選擇「擴充功能」',
          '在擴充功能列表介面下拉到最底部，點擊「尋找更多擴充功能」，跳轉到擴充功能商店',
          '在商店搜尋框中輸入「隱分寶」進行搜尋',
          '打開詳情頁後點擊「添加到 Firefox」，對彈窗點擊「添加」，顯示安裝成功',
          '特別注意：安裝成功後需先打開任意一個網頁，再點擊右上角選單 → 「擴充功能」，此時列表中已多出隱分寶',
          '點擊隱分寶，在彈出介面中點擊「進入管理控制台」，即可正常觀賽；也可點擊左側選單列自訂觀賽設定'
        ]
      },
      links: {
        manualGuideText: '前往手動安裝指南',
        manualGuideHint: '支援瀏覽器清單 + 開發者模式拖拽安裝步驟',
        apkText: 'Firefox APK 下載（Mozilla 官方網站）',
        apkHref: 'https://ftp.mozilla.org/pub/fenix/releases/152.0.5/android/fenix-152.0.5-android-arm64-v8a/'
      },
      chromiumCta: '查看手動安裝指南',
      doneText: '至此所有安裝步驟已完成，可以放心使用了',
      noticeTitle: '友情提示',
      notice: '只對隱分寶控制台中打開的首個網頁可以實現劇透遮擋效果，對其他非隱分寶來源打開的任意網站，無法實現劇透隱藏效果。',
      ios: {
        title: 'iOS / iPadOS 暫不支援',
        reason: 'iOS 受 Apple 系統限制，瀏覽器無法載入擴充功能。',
        note: '後續若 iOS 端方案成熟，我們會第一時間在官網更新。'
      },
      helpLine: '需要協助？聯絡 {email}'
    },

    store: {
      title: '商店安裝',
      subtitle: '一鍵安裝到你的瀏覽器，自動更新，最省心',
      detectedBadge: '推薦',
      detectedCta: '前往 {browser} 商店安裝',
      fallbackHint: '不是 {browser}？選擇其他瀏覽器',
      fallbackLabel: '選擇瀏覽器',
      backToInstall: '返回安裝方式',

      methodStore: '應用商店一鍵安裝',

      browsers: {
        chrome: 'Chrome',
        edge: 'Edge',
        firefox: 'Firefox'
      },
      platforms: {
        desktop: '桌面端',
        android: 'Android',
        ios: 'iOS',
        harmonyos: 'HarmonyOS'
      },
      unavailable: '暫不支援',
      useDesktop: '請使用桌面端瀏覽器（Chrome / Edge / Firefox 任一均可）獲得完整體驗。',
      backToStore: '返回安裝指南',

      chrome: {
        desktop: {
          title: 'Chrome 桌面端安裝',
          subtitle: 'Windows / macOS / Linux',
          storeSteps: [
            '打開 Chrome 瀏覽器',
            '前往 Chrome 網上應用店',
            '搜尋「隱分寶」',
            '點擊「添加到 Chrome」',
            '在彈出視窗中點擊「添加擴充功能」，並勾選授予所需存取權限',
            '安裝完成後，右上角擴充功能欄顯示隱分寶圖示；建議固定到工具列方便快速開關',
            '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
            '在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
          ]
        },
        android: {
          title: 'Chrome · Android',
          unavailableReason: 'Chrome 瀏覽器目前不支援 Android 端擴充功能安裝。建議改用 Edge 或 Firefox 瀏覽器。'
        },
        ios: {
          title: 'Chrome · iOS',
          unavailableReason: 'Chrome 瀏覽器目前不支援 iOS 端擴充功能安裝。'
        },
        harmonyos: {
          title: 'Chrome · HarmonyOS',
          unavailableReason: 'Chrome 瀏覽器目前不支援 HarmonyOS 端擴充功能安裝。建議改用 Edge 或 Firefox 瀏覽器。'
        }
      },

      edge: {
        desktop: {
          title: 'Edge 桌面端安裝',
          subtitle: 'Windows / macOS / Linux',
          storeSteps: [
            '打開 Edge 瀏覽器',
            '前往 Edge 載入項商店',
            '搜尋「隱分寶」',
            '點擊「獲取」',
            '在彈出視窗中點擊「添加擴充功能」，並勾選授予所需存取權限',
            '安裝完成後，建議把擴充功能固定到工具列方便快速開關',
            '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
            '在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
          ]
        },
        android: {
          title: 'Edge · Android',
          storeSteps: [
            '在手機上安裝 Edge 瀏覽器（各大應用商店）',
            '打開 Edge，進入首頁點擊選單列圖示',
            '在選單介面點擊「擴充功能」，打開擴充功能管理介面',
            '搜尋「隱分寶」，點擊「獲取」',
            '彈出提示後點擊「添加」，顯示已安裝',
            '回到首頁打開選單 → 「擴充功能」，點擊隱分寶',
            '在彈出介面點擊「進入控制台」，即可正常觀賽；也可點擊左側選單列自訂觀賽設定'
          ]
        },
        ios: {
          title: 'Edge · iOS',
          unavailableReason: 'Edge 瀏覽器目前不支援 iOS 端擴充功能安裝。'
        },
        harmonyos: {
          title: 'Edge · HarmonyOS',
          storeSteps: [
            '在手機上安裝 Edge 瀏覽器（各大應用商店）',
            '打開 Edge，進入首頁點擊選單列圖示',
            '在選單介面點擊「擴充功能」，打開擴充功能管理介面',
            '搜尋「隱分寶」，點擊「獲取」',
            '彈出提示後點擊「添加」，顯示已安裝',
            '回到首頁打開選單 → 「擴充功能」，點擊隱分寶',
            '在彈出介面點擊「進入控制台」，即可正常觀賽；也可點擊左側選單列自訂觀賽設定'
          ]
        }
      },

      firefox: {
        desktop: {
          title: 'Firefox 桌面端安裝',
          subtitle: 'Windows / macOS / Linux',
          storeSteps: [
            '打開 Firefox 瀏覽器',
            '前往 Firefox 附加元件商店',
            '搜尋「隱分寶」',
            '點擊「添加到 Firefox」',
            '在彈出視窗中點擊「添加」，並勾選授予所需存取權限',
            '安裝完成後，建議把擴充功能固定到工具列方便快速開關',
            '點擊隱分寶圖示，彈出小視窗後點擊「進入管理控制台」',
            '在賽事導航中選比賽前往觀賽，也可以點擊左側選單列自訂觀賽設定'
          ]
        },
        android: {
          title: 'Firefox · Android',
          storeSteps: [
            '在手機上安裝 Firefox 瀏覽器（應用商店搜尋，或透過 Mozilla 官方網站下載 APK）',
            '打開 Firefox，點擊首頁右上角選單圖示',
            '在展開的選單中選擇「擴充功能」',
            '下拉到最底部，點擊「尋找更多擴充功能」，跳轉到擴充功能商店',
            '搜尋「隱分寶」，打開詳情頁後點擊「添加到 Firefox」',
            '彈出視窗點擊「添加」，顯示安裝成功',
            '注意：需先打開任意一個網頁，再點擊右上角選單 → 「擴充功能」，列表中已多出隱分寶',
            '點擊隱分寶，在彈出介面點擊「進入管理控制台」，即可正常觀賽；也可點擊左側選單列自訂觀賽設定'
          ]
        },
        ios: {
          title: 'Firefox · iOS',
          unavailableReason: 'Firefox 瀏覽器目前不支援 iOS 端擴充功能安裝。'
        },
        harmonyos: {
          title: 'Firefox · HarmonyOS',
          storeSteps: [
            '在手機上安裝 Firefox 瀏覽器（應用商店搜尋，或透過 Mozilla 官方網站下載 APK）',
            '打開 Firefox，點擊首頁右上角選單圖示',
            '在展開的選單中選擇「擴充功能」',
            '下拉到最底部，點擊「尋找更多擴充功能」，跳轉到擴充功能商店',
            '搜尋「隱分寶」，打開詳情頁後點擊「添加到 Firefox」',
            '彈出視窗點擊「添加」，顯示安裝成功',
            '注意：需先打開任意一個網頁，再點擊右上角選單 → 「擴充功能」，列表中已多出隱分寶',
            '點擊隱分寶，在彈出介面點擊「進入管理控制台」，即可正常觀賽；也可點擊左側選單列自訂觀賽設定'
          ]
        }
      }
    },

    manual: {
      title: '手動安裝 .crx',
      subtitle: '適用於所有基於 Chromium 核心的瀏覽器，包括未上架商店的國產瀏覽器',
      platformSupport: {
        title: '平台支援說明',
        items: [
          {
            mark: '✓',
            status: 'recommended',
            name: '桌面端',
            hint: '推薦。Windows / macOS 全面支援，可獲得完整體驗。'
          },
          {
            mark: '△',
            status: 'partial',
            name: 'Android',
            hint: '部分支援。請使用支援載入 .crx 的瀏覽器（如 弧猴瀏覽器、Kiwi Browser 等）。'
          },
          {
            mark: '✗',
            status: 'unsupported',
            name: 'iOS',
            hint: '不支援。受 Apple 限制，瀏覽器無法正常安裝擴充功能。'
          }
        ]
      },
      supportedTitle: '支援的瀏覽器',
      supportedBrowsers: [
        'Google Chrome',
        '360 極速瀏覽器',
        'QQ 瀏覽器',
        '搜狗高速瀏覽器',
        '360 瀏覽器',
        '獵豹瀏覽器',
        'Opera',
        'UC 瀏覽器'
      ],
      stepsTitle: '安裝步驟',
      steps: [
        '下載 .crx 安裝套件到本地',
        '點擊瀏覽器選單圖示，找到「擴充功能 / 附加元件管理」頁面（一般在「設定 / 工具 / 擴充功能」裡）',
        '打開頁面右上角的「開發者模式」開關',
        '將下載好的 .crx 檔案從資料夾中直接拖拽到擴充功能頁面中',
        '在彈出的提示視窗中，點擊「添加 / 安裝」，並勾選授予所需存取權限',
        '安裝完成後，建議把擴充功能固定到工具列，方便後續一鍵開關'
      ],
      downloadCta: '下載 .crx 安裝套件',
      backToInstall: '返回安裝指南',
      supportedNote: '僅支援桌面端瀏覽器（Windows / macOS）',
      helpLine: '需要協助？聯絡 {email}'
    }
  },

  download: {
    title: '下載隱分寶',
    subtitle: '已為您自動識別瀏覽器，點擊下方按鈕下載安裝套件',
    detectingBrowser: '正在識別瀏覽器...',
    directDownload: '直接下載',
    fallbackHint: '如未自動識別，請手動選擇瀏覽器',
    viewOnStore: '前往商店'
  },

  about: {
    title: '關於隱分寶',
    intro: '@:product.aboutIntro',
    capabilitiesTitle: '核心能力',
    sitesTitle: '支援站點',
    sitesHint: '已支援 {count} 個主流體育視訊網站',
    communityTitle: '公眾號與反饋群',
    communityHint: '關注公眾號獲取更新動態，加入反饋群提交建議',
    wechatGzh: {
      title: '微信公眾號（膨脹的球）',
      hint: '微信公眾號搜尋「膨脹的球」即可關注'
    },
    wechatGroup: {
      title: '微信反饋交流群',
      hint: '掃描 QR Code 加入使用者反饋與交流群'
    },
    authorTitle: '關於作者',
    authorContent: '由 膨脹（SwellMan）獨立開發與維護。從最初為了自己不被回放劇透打擾的小工具，慢慢長成了支援三大瀏覽器、覆蓋十多個主流體育視訊網站的玩家必備。期待它能幫你找回第一次看球時的那份心跳。',
    contactTitle: '聯絡方式',
    contactEmailLabel: '回饋信箱',
    legalTitle: '法律協議',
    legalLinks: {
      privacy: '隱私政策',
      terms: '使用者協議',
    }
  },

  // 支援站點名稱（Home / About 共用；擴充套件端也按官方名展示）
  sites: {
    migu: { name: '咪咕視頻' },
    iqiyi: { name: '愛奇藝' },
    bilibili: { name: '嗶哩嗶哩' },
    cctv: { name: '央視網' },
    yangshipin: { name: '央視頻' },
    tencent: { name: '騰訊視頻' },
    douyin: { name: '抖音' },
    weibo: { name: '微博' },
    xiaohongshu: { name: '小紅書' }
  },

  privacy: {
    title: '隱私政策',
    subtitle: '我們對您隱私的承諾',
    intro: '我們尊重並保護每一位使用者的隱私。本政策以清晰易懂的方式，向您說明我們的產品會收集哪些資訊、為什麼收集、如何使用、如何保護，以及您對自己的資訊享有哪些權利。',
    principlesTitle: '核心原則',
    principles: [
      {
        title: '資料本地優先',
        desc: '產品的中核功能——識別與隱藏劇透資訊——全部在您的瀏覽器本地完成，瀏覽內容不會上傳到我們的伺服器。'
      },
      {
        title: '不追蹤',
        desc: '我們不追蹤您的瀏覽歷史，不收集您的瀏覽行為，不建立任何形式的使用者畫像。'
      },
      {
        title: '零廣告',
        desc: '產品無廣告版位、無推廣合作、無第三方追蹤腳本；訂閱僅用於支持持續開發。'
      },
      {
        title: '最小必要',
        desc: '我們只申請實現核心功能所必需的瀏覽器權限；任何權限的變更都會同步更新本政策。'
      }
    ],
    sections: {
      scope: {
        title: '一、本政策適用範圍',
        content: '本政策適用於「Replay Shield」（中文名稱「隱分寶」）瀏覽器擴充功能及本網站 woofootball.site。下文中「產品」或「我們」指代上述擴充功能與網站的營運方。本政策不適用於您透過我們的擴充功能所存取的任何第三方網站——那些網站各自擁有獨立的隱私政策，請參閱其各自的說明。'
      },
      whatWeCollect: {
        title: '二、我們收集哪些資訊',
        items: [
          '您主動提交的資訊：當您透過「意見反饋」等管道聯絡我們時，我們會收到您選擇填寫的內容（例如郵箱、問題描述、附圖等）。',
          '擴充功能偏好設定：您選擇的語言、主題、隱藏規則開關等偏好儲存在您的瀏覽器本地，僅在本地用於產品運行。',
          '必要的安全日誌：當我們提供的介面收到請求時，會按照業界通行做法記錄必要的資訊（例如請求時間、必要的網路識別等），用於安全稽核、故障排查與防濫用。',
          '支付與訂單資訊：當您開通 Pro 會員時，我們會處理完成訂閱訂單所必需的資訊（例如訂單號、套餐與金額、支付管道回傳的交易憑證、退款原因與審核記錄），僅用於訂單處理、財務核對、退款審核與客戶服務。'
        ]
      },
      permissions: {
        title: '三、瀏覽器權限說明',
        intro: '為實現核心功能，擴充功能需要向瀏覽器申請若干權限。下方我們以「用途」而非「權限名稱」逐項說明——這樣更便於您理解我們能用這些權限做什麼、不能做什麼。',
        items: [
          '存取當前頁面內容：用於在您存取受支援的體育影片頁面時，根據您設定的規則隱藏劇透元素。該能力僅在您主動操作擴充功能或命中受支援頁面時使用。',
          '本機儲存偏好：將您選擇的語言、主題、規則開關等儲存在瀏覽器本地，您可以隨時在擴充功能設定中查看與清除。',
          '向受支援的體育影片網站注入樣式規則：僅在我們維護的一份網站清單上套用隱藏規則。當前清單可在擴充功能設定中查看，並隨產品迭代更新。',
          '接收您的主動指令：回應您點擊擴充功能圖示、切換設定、提交反饋等操作。'
        ]
      },
      dataRetention: {
        title: '四、資料保留與刪除',
        items: [
          '本地偏好：儲存在您的瀏覽器本地，直至您解除安裝擴充功能、清除擴充資料或手動重置。',
          '反饋資訊：僅在處理您所提問題的合理必要期限內保留，問題處理完畢後即行刪除或匿名化。',
          '安全日誌：僅在保障服務安全、排查故障、應對安全事件所必要的期限內保留，具體期限遵循業界通行做法與適用法律。',
          '如您希望我們刪除您主動提交的資訊，請透過本政策末尾的聯絡方式與我們聯絡。'
        ]
      },
      userRights: {
        title: '五、您對個人資訊的權利',
        intro: '我們尊重您對個人資訊享有的權利。您可以：',
        items: [
          '查詢、複製我們持有的與您有關的個人資訊',
          '更正或補充不準確、不完整的資訊',
          '在符合法律規定的條件下，要求我們刪除相關資訊',
          '撤回您此前作出的同意',
          '透過本政策末尾的聯絡方式向我們提出疑問、投訴或舉報'
        ],
        closing: '由於本產品不設帳號體系，絕大部分偏好資訊儲存在您的本地裝置，您可以直接透過擴充功能設定或瀏覽器的資料管理功能行使上述權利。對於需要我們協助處理的部分，請透過下方聯絡方式與我們聯絡，我們將在合理期限內回應。'
      },
      security: {
        title: '六、我們如何保護您的資訊',
        items: [
          '我們使用業界通行的加密傳輸與簽章機制保護我們與您瀏覽器之間的通訊',
          '本地資料儲存在瀏覽器提供的、與普通網頁隔離的區域',
          '我們持續關注業界安全實務，並按需更新我們的防護措施',
          '但請理解：沒有任何系統能夠保證絕對安全。如發生安全事件，我們將依法及時告知您'
        ]
      },
      crossBorder: {
        title: '七、跨境傳輸',
        content: '我們的服務基礎設施部署在中國大陸境內。預設情況下，您的資訊均在境內處理；如您從境外使用產品，必要的網路通訊將按照適用法律進行。我們不會主動將您的個人資訊向境外提供。'
      },
      children: {
        title: '八、兒童隱私',
        content: '本產品不針對未滿十四周歲的未成年人單獨設計。如未成年人使用本產品，應在其監護人同意的前提下進行。我們不會主動收集未成年人的個人資訊；如您作為監護人發現未成年人未經同意提交了個人資訊，請透過本政策末尾的聯絡方式與我們聯絡，我們將協助處理。'
      },
      thirdParty: {
        title: '九、第三方連結與服務',
        content: '我們的產品可能包含前往第三方瀏覽器應用商店、其他第三方網站的連結，或在受支援的第三方體育影片網站上運作。這些第三方各自擁有獨立的隱私政策與使用者協議，我們無法控制其做法。建議您在使用前查閱相關第三方的政策。'
      },
      updates: {
        title: '十、本政策的更新',
        content: '我們可能根據產品迭代、法律法規變化等情況更新本政策。對於重大變更，我們會透過擴充功能內的「版本更新」頁面與官網公告提前告知。變更生效後繼續使用本產品，即視為您接受變更後的政策。'
      },
      contact: {
        title: '十一、聯絡我們',
        content: '如您對本政策、對您個人資訊的處理有任何疑問，或希望行使本政策賦予您的權利，請透過以下郵箱與我們聯絡：'
      }
    }
  },

  terms: {
    title: '使用者協議',
    subtitle: '使用本產品前請閱讀',
    intro: '歡迎使用「Replay Shield」（中文名稱「隱分寶」）及其官方網站（下文統稱「產品」）。本協議是您與營運方之間就使用本產品所訂立的協議。請仔細閱讀本協議全部條款；使用本產品即視為您已閱讀、理解並同意本協議。',
    sections: {
      service: {
        title: '一、服務內容',
        content: '本產品是一款瀏覽器擴充功能，為觀看體育比賽回放或精彩集錦的使用者提供比分、標題、封面、評論等劇透資訊的本地隱藏功能；同時本網站為上述功能提供介紹、安裝與下載入口。服務採用免費 + 訂閱制（基礎功能免費使用，Pro 會員為付費訂閱），新用戶註冊可享 Pro 試用，試用期內功能不受限制。'
      },
      subscriptionPay: {
        title: '二、訂閱、支付與退款',
        intro: '本節說明 Pro 會員訂閱服務相關的計價、支付、權益入帳與退款規則。《退款政策》為本節的細化約定，二者不一致時以《退款政策》為準。',
        items: [
          '定價與費用：套餐價格以訂閱頁展示為準；活動期間按折扣價計算，活動結束後恢復原價。透過邀請連結註冊並綁定的好友，首次開通時享受受邀首單折扣；下單時若有多個候選折扣，可在收銀台自行選擇（預設依最優計算）。',
          '支付管道：支付由第三方管道（支付寶等）提供，並可能在支付環節收取少量手續費。',
          '權益入帳：權益在支付成功後依「未使用時長順延」方式疊加計算（即總有效期 = 目前有效期與當前時間之較大者 + 本次時長），支付成功前不發放權益。',
          '退款規則：本產品為虛擬數位商品，用戶側預設不提供主動退款入口；因產品問題等特殊情況確需退款時，經營運方核實開放退款權限後，依已使用天數比例清算退款（已使用天數含開通當天，無 100% 退款）；退款成功後對應邀請獎勵全額收回、首單資格不返還。試用、兌換碼、邀請獎勵、贈送取得的權益不參與退款。具體約定見《退款政策》。',
          '服務範圍與限制：本產品依「現狀」提供，僅對受支援頁面的本地遮擋負責，不保證所有頁面、所有時刻的完整覆蓋；因第三方站點改版、頁面結構變化等導致的隱藏失效，運營方不承擔超出實付金額的責任。',
          '服務終止：如運營方停止提供訂閱服務，對使用者尚未消耗的付費時長將按比例退還尚未消耗金額。'
        ]
      },
      license: {
        title: '三、使用許可',
        content: '營運方授予您非獨佔、不可轉讓、可撤銷的使用本產品的權利。您可在符合所在國家/地區法律法規的前提下，於個人裝置上安裝並使用本擴充功能。營運方保留隨時暫停或終止部分或全部服務的權利。'
      },
      intellectualProperty: {
        title: '四、智慧財產權',
        items: [
          '本產品的名稱、標誌、介面設計、圖示、文案等受智慧財產權保護，未經營運方書面授權不得使用',
          '本產品中使用的開源元件及其授權資訊，詳見擴充功能內的「關於」頁面',
          '本產品運作所涉及的第三方網站名稱、標誌、網域等，為其各自所有者的商標；營運方與之不存在代言、授權或合作關係'
        ]
      },
      restrictions: {
        title: '五、使用限制',
        items: [
          '不得對本產品進行反向工程、反編譯、反組譯或試圖提取原始碼',
          '不得對本產品進行修改、二次開發、再散布或商業轉售',
          '不得利用本產品從事任何違反所在地法律法規的活動',
          '不得利用本產品繞過任何第三方網站的存取控制、付費牆或訂閱驗證',
          '不得利用本產品對任何第三人進行騷擾、詐欺、傳播違法或不當資訊'
        ]
      },
      specificFeatures: {
        title: '六、特定功能使用聲明',
        intro: '本節就產品中的核心隱藏功能向您作進一步說明，以便您了解其法律性質與責任邊界。',
        items: [
          '本產品對受支援網站上的劇透元素所進行的處理，全部在您本地的瀏覽器中完成。',
          '本產品不複製、不傳播、不再散布任何第三方網站的內容。',
          '本產品不繞過付費牆、不獲取付費內容、不規避訂閱驗證。',
          '本產品不會修改第三方網站的伺服器端資料。',
          '本產品與本協議第三條所列第三方網站之間不存在任何官方合作關係。',
          '由於第三方網站的頁面結構持續迭代，本產品的隱藏規則可能因網站改版而局部失效；營運方將持續適配，但不承諾任何時刻下規則的即時有效性。',
          '在使用本產品的隱藏功能前，請確認您所在司法管轄區的法律以及目標網站的使用者協議是否允許此類本地化處理；如有任何疑慮，請停止使用相關功能。',
          '營運方對您使用本產品隱藏功能所引發的任何第三方糾紛、帳號封禁或合規問題不承擔任何責任；相關合規風險由您本人承擔。'
        ]
      },
      disclaimer: {
        title: '七、免責聲明',
        items: [
          '本產品按「現狀」提供，營運方不對特定適用性、穩定性、不中斷性作任何明示或暗示的擔保',
          '因第三方網站頁面改版導致部分隱藏規則失效的情況，營運方不承擔責任',
          '因您裝置環境、網路狀況、瀏覽器版本差異導致的功能異常，營運方不承擔責任',
          '營運方不對您因使用本產品產生的任何間接、偶然、特殊或衍生損失承擔責任',
          '在任何情況下，營運方依本協議所承擔的累計責任，以您為本產品支付的費用（如有）為限；由於本產品當前階段的訂閱服務可能涉及付費，前述金額以您實際支付的費用為限'
        ]
      },
      updates: {
        title: '八、協議變更',
        content: '營運方有權根據產品迭代、法律法規變化等情況修改本協議。修改後的協議會透過官網公告與擴充功能內的「版本更新」頁面告知。繼續使用本產品即視為您接受修改後的協議。'
      },
      dispute: {
        title: '九、爭議解決',
        content: '因本協議引起的或與本協議相關的任何爭議，雙方應首先透過友好協商解決。協商不成的，任何一方可向營運方所在地有管轄權的人民法院提起訴訟。'
      },
      law: {
        title: '十、法律適用',
        content: '本協議的解釋、效力及爭議解決均適用中華人民共和國（為本協議之目的，不包括香港特別行政區、澳門特別行政區和臺灣地區）法律。'
      }
    }
  },


refund: {
    title: '退款政策',
    subtitle: '訂閱退款規則與說明',
    meta: '生效日期 · 2026-09-06',
    intro: '本政策約定「隱分寶」Pro 會員訂閱服務的退款與補償規則。「隱分寶」為虛擬數位商品服務，開通即消耗服務資源，故不提供「無理由全額退款」；如你確需退款（且帳號經運營方核實開放退款權限），將依已使用天數比例清算，退款金額 = 實付 × 剩餘天數 ÷ 套餐天數（向下取分），已使用天數含開通當天，無 100% 退款。請在下單前閱讀本政策；點擊支付即視為你已了解並同意本政策。',
    sections: {
      scope: {
        title: '一、適用範圍',
        content: '本政策適用於運營方向「隱分寶」使用者提供的 Pro 會員訂閱服務的退款與補償處理。試用、兌換碼、邀請獎勵、運營方贈送或調整的權益均不涉及實付出資，不在退款範圍內。'
      },
      window: {
        title: '二、退款權限與入口',
        items: [
          '使用者側預設不提供主動退款入口；如因產品問題、系統失誤、誤購等特殊情況需要退款，可在瀏覽器擴充功能的「意見回饋」中說明情況。',
          '運營方核實情況後，可在後台為該使用者開放退款權限。權限開放後，其名下「已支付」且仍有剩餘天數的訂閱訂單即可自助申請退款。',
          '退款權限是否開放、何時開放由運營方視具體情況決定，不代表對任何訂單的退款承諾。'
        ]
      },
      calc: {
        title: '三、退款金額計算',
        intro: '退款依自然日比例清算，規則如下：',
        items: [
          '已使用天數 = 申請日 − 開通日 + 1（含開通當天；開通當天即申請也計為已用 1 天，無 100% 退款）。',
          '剩餘天數 = 套餐總天數 − 已使用天數；剩餘天數 ≤ 0 時不可退款。',
          '退款金額 = 實付金額 × 剩餘天數 ÷ 套餐總天數（向下取分到分）。範例：開通 30 天月度會員第 3 天申請，退 28/30 的實付金額。',
          '退款金額僅基於本單實付（折後價），不按套餐原價折算；活動價/折扣購買後退款依實付計算。',
          '如因產品問題、系統失誤或漏洞影響使用體驗，可在瀏覽器擴充功能的「回饋」中提交說明，經核實後運營方可能發放 Pro 會員天數補償（補償為會員時長，非現金退款），或依上述口徑為你開放退款權限。'
        ]
      },
      process: {
        title: '四、申請與處理流程',
        items: [
          '退款權限開放後，在個人中心「我的訂單」訂單詳情中，對狀態為「已支付」的訂單點擊「申請退款」。',
          '彈窗將展示退款明細：開通日期、套餐天數、已使用天數（含今天）、剩餘天數、實付金額與本次退款金額，請核對後勾選《退款政策》並確認。',
          '確認後系統自動執行退款並原路退回，無需人工審核；請確認退款明細無誤後再送出，送出後不可撤回。',
          '退款發起失敗（渠道異常等）：訂單停留「退款處理中」，由運營方在後台補退佇列人工處理，你可稍後查看訂單狀態。'
        ]
      },
      notApplicable: {
        title: '五、不適用情形',
        items: [
          '帳號未獲運營方開放退款權限。',
          '訂單對應的付費服務段已全部消耗完畢（剩餘天數 ≤ 0）。',
          '試用、兌換碼、邀請獎勵、運營方贈送或調整的權益（未實付）。',
          '已退款完成的同一訂單（終態，不可重複退款）。'
        ]
      },
      coverage: {
        title: '六、服務範圍與限制',
        intro: '退款涉及權益折算，請一併了解產品服務的覆蓋邊界：',
        items: [
          '本產品僅對「支援的網站」中設定的影片頁面提供劇透資訊遮擋；網站首頁、列表頁以及不在支援清單中的網站不在服務範圍。',
          '直接開啟的支援站點影片頁面可提供遮擋；從該頁面連續開啟的其他頁面（更深層頁面、站內跳轉產生的頁面）不保證遮擋。',
          '受支援的第三方站點可能隨時改版（頁面結構、路由、播放器等變化），可能造成遮擋失效、錯位或部分失效。運營方會持續適配，但不承諾任何時刻、任何頁面的完整遮擋。',
          '網路異常、站點要求登入、地區限制等環境因素導致頁面內容變化或無法存取時，防護可能不可用；規則缺失或異常時，產品會顯示「防護服務暫時不可用」提示並允許繼續觀看，運營方不對劇透資訊被看到承擔賠償責任。'
        ]
      },
      compensation: {
        title: '七、產品問題補償',
        content: '為保障 Pro 會員權益：如你在使用過程中遇到產品問題、系統失誤或漏洞影響體驗，可在瀏覽器擴充功能的「回饋」中提交說明（含問題類型與描述）。我們核實為真實問題後，將即時發放 Pro 會員天數補償（補償為會員時長，非現金退款），發放結果與官方回覆可在擴充功能「我的回饋」中查看。'
      },
      rewards: {
        title: '八、邀請獎勵與退款',
        content: '邀請獎勵基於好友的實際開通發放。若好友的訂閱訂單發生退款，已發放的對應邀請獎勵將全額收回（該部分流水標記為已退款），邀請者權益依剩餘有效流水重新計算。註冊級邀請獎勵（+5 天）不因好友退款而回收。'
      },
      termination: {
        title: '九、服務終止',
        content: '如運營方停止提供全部或部分訂閱服務，對使用者尚未消耗的付費時長，將按本政策口徑按比例退還尚未消耗金額。'
      },
      invoice: {
        title: '十、發票',
        content: '運營方現階段暫不提供發票。如你確需發票，建議暫緩開通。'
      },
      autoRenew: {
        title: '十一、自動續費',
        content: '目前產品不提供自動續費。如未來上線自動續費，將依法律法規要求對使用者進行顯著提示與確認，並提供簡便的取消途徑，屆時同步更新本政策。'
      },
      dispute: {
        title: '十二、異議與聯絡',
        content: "如你對退款結果、金額計算或訂單處理有異議，可寄送郵件至 woofootball@aliyun.com，我們將在合理期限內覆核並回覆。"
      }
    }
  },

  inviteRules: {
    title: '邀請規則',
    subtitle: '隱分寶 Pro 邀請機制說明',
    meta: '更新日期 · 2026-09-06',
    intro: '邀請好友使用隱分寶 Pro，好友與你都能獲得獎勵。本頁說明邀請關係的綁定規則與獎勵發放口徑。透過邀請連結註冊即視為已了解本規則。',
    sections: {
      bind: {
        title: '一、綁定規則',
        items: [
          '透過邀請連結（或填寫邀請碼）註冊新帳號時，即與邀請人建立邀請關係，關係終身有效、不可更改或解除。',
          '邀請歸因僅在 24 小時內有效：點擊邀請連結後 24 小時內完成註冊才會計入邀請關係；超過 24 小時連結失效，註冊將不綁定任何邀請人。',
          '自己邀請自己無效；已註冊的老用戶透過連結下單不會補綁邀請關係（下單時如偵測到未綁定邀請會先徵得你的確認）。',
          '每位使用者只有一個邀請碼，可在個人中心「我的邀請」中查看與複製。'
        ]
      },
      discount: {
        title: '二、受邀優惠',
        items: [
          '受邀好友首次訂閱可享受受邀首單折扣，具體力度以頁面展示為準。',
          '首單優惠與限時活動、首訂優惠互斥不疊加，系統自動依對你最優惠的一項計算；下單時若存在多個候選折扣，可在收銀台自行選擇（含不使用優惠）。',
          '任何形式的首次訂閱（含活動價）都會消耗首單優惠資格，資格不保留不順延；退款也不返還首單資格。'
        ]
      },
      reward: {
        title: '三、邀請獎勵',
        items: [
          '註冊獎勵：好友透過你的邀請註冊成功後，你立即獲得 5 天會員獎勵（每自然年透過註冊獎勵累計最多 365 天）。',
          '訂閱獎勵：好友首次訂閱成功（任意套餐）後，你獲得該套餐時長一半的獎勵（向上取整；月度 30 天得 15 天、季度 90 天得 45 天、年度 365 天得 183 天）。',
          '訂閱獎勵每個好友僅發放一次（僅限首次訂閱）；好友續費不再觸發。'
        ]
      },
      refund: {
        title: '四、退款與收回',
        items: [
          '若好友的首次訂閱訂單發生退款，你因該訂單獲得的訂閱獎勵將被全額收回，權益流水會標記「已收回」並重新計算你的會員到期時間。',
          '註冊獎勵（+5 天）不因好友退款而收回。',
          '好友退款依天數比例清算，與你的獎勵收回互不影響：好友實際使用期間的獎勵也不保留。'
        ]
      },
      display: {
        title: '五、獎勵查詢',
        content: '你可在個人中心「我的邀請」查看邀請碼、邀請連結與全部邀請獎勵流水；「權益流水」中每筆邀請獎勵會把來源直接標在記錄上（節點 · 好友脫敏帳號 · 套餐），被收回的記錄標記「已收回」。'
      }
    }
  },

  notFound: {
    title: '頁面未找到',
    desc: '您訪問的頁面不存在或已被移除。',
    backHome: '返回首頁'
  }
} as const
